@import "../../scss/mixins";

:host {
  display: block;
  display: flex;
  align-items: center;
  justify-content: center;
}

input,
textarea {
  box-sizing: border-box;
}

@keyframes slideIn {
  0% {
    transform: translateY(400px);
    animation-timing-function: ease-out;
  }
  80% {
    transform: translateY(10px);
    animation-timing-function: ease-out;
  }
  100% {
    transform: translateY(0px);
    animation-timing-function: ease-in;
  }
}

@keyframes fadeIn {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

.content {
  position: relative;
  background-color: #191d36;
  color: #e3e3e5;
  padding: 1.5rem;
  min-width: 500px;
  animation: fadeIn 1s, slideIn 0.8s linear;
  max-width: 500px;
}

.close-button {
  background-color: transparent !important;
  border: none;
  font-size: 1.75rem !important;
  font-weight: 200;
  cursor: pointer;
  color: var(--color-dark-500) !important;
  padding: 0 !important;
}

.top-section {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  vertical-align: middle;
  margin-bottom: 18px;

  .location {
    max-width: 75%;
    display: flex;
    flex-direction: column;
    gap: 5px;

    h2 {
      font-size: 16px;
      font-weight: 400;
      margin: 0;
      display: inline-flex;
    }

    span {
      margin-left: 10px;
      font-size: 12px;
    }

    p {
      font-size: 12px;
    }
  }
}

form label {
  display: block;
  margin-bottom: 5px;
  color: #a8b5f7;
  font-size: 12px;
  font-weight: 400;
}

.input-group {
  margin-bottom: 1.5rem;
}

input,
textarea {
  width: 100%;
  padding: 0.5rem;
  font-size: 14px;
  border-radius: 2px;
  border: 1px solid #616fb5;
  background: #191d36;
  color: #e3e3e5;
  font-family: "Rubik", "Barlow", sans-serif;
  font-weight: 400;
  font-size: 14px;
  resize: none;

  // placeholder
  &::placeholder {
    color: #616fb5bd;
    font-family: "Rubik", "Barlow", sans-serif;
    font-weight: 400;
    font-size: 14px;
  }

  &:focus {
    outline: none;
    border-color: #a8b5f7;
  }
}

textarea {
  height: 120px;
}

.footer {
  display: flex;
  justify-content: space-between;

  .required-warning {
    font-size: 0.8rem;
    color: #a8b5f7;
    margin-top: -15px;
  }
}

.error,
.form-error {
  display: block;
  color: #d13f45;
  font-size: 0.875rem;
  margin-top: 0.25rem;
}

.form-error {
  font-size: 1.25rem;
  margin-top: 1rem;
  inline-size: 500px;
  overflow-wrap: break-word;
}

.success-message {
  color: #e3e3e5;
  font-size: 1.25rem;
  inline-size: 500px;
  overflow-wrap: break-word;

  button {
    align-self: flex-end;
  }

  h2 {
    font-size: 2rem;
    margin-bottom: 0.5rem;
  }
  p {
    font-size: 1.25rem;
    margin-bottom: 2rem;
  }
}

.btn-container {
  display: flex;
  justify-content: space-between;
  margin-top: 1rem;

  .login-btn {
    background-color: #e3e3e5;
    color: #191d36;
  }
}

#submit-button {
  @include sitenna-button;
}

.close-form-button {
  @include sitenna-button;
}

.phone-group {
  display: grid;
  grid-template-columns: 2.5fr 7.5fr;
  gap: 10px;
}

.intl-wrapper {
  position: relative;

  span {
    font-size: 14px;
    position: absolute;
    left: 10px;
    top: 6px;
    z-index: 1;
  }

  #intl-code {
    padding-left: 20px; /* Adjust the padding to provide space for the '+' symbol */
  }
}

// hide arrows beside input type number for chrome and firefox
input[type="number"]::-webkit-outer-spin-button,
input[type="number"]::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Hide arrows for number input in Firefox */
input[type="number"] {
  -moz-appearance: textfield;
  appearance: textfield;
}
